import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { projectDomainName } from 'shared/constants'

import { selectIsUserAuthenticated, selectUserData } from 'features/auth/selectors'
import { getDigitainSlotToken, removeDigitainSlotToken } from 'features/slots/actions'
import { selectDigitainSlotToken } from 'features/slots/selectors'

import { slotProvidersConfiguration } from '../configuration'
import { Providers } from '../types/configuration'

const isHasDigitainIntegration = !!slotProvidersConfiguration?.[Providers.digitain]

export const useDigitainSlotToken = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const userId = useSelector(selectUserData, shallowEqual)?.id
  const token = useSelector(selectDigitainSlotToken, shallowEqual)

  useEffect(() => {
    if (!isHasDigitainIntegration) return

    if (isAuth && token === '-') {
      dispatch(getDigitainSlotToken({ user_id: userId || 0, project_slug: projectDomainName }))
    } else if (!isAuth && token !== '-') {
      dispatch(removeDigitainSlotToken())
    }
  }, [isAuth, token])
}
